"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgGlobe = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 13c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11c0-5.979 4.77-10.843 10.712-10.996L24 13zm-4.947 12.001h-3.998a9.008 9.008 0 006.671 7.71A16.33 16.33 0 0119.053 25zm13.892 0H28.95a16.3 16.3 0 01-2.675 7.709 9.007 9.007 0 006.67-7.71zm-6 0h-5.887A14.3 14.3 0 0024 32.449 14.288 14.288 0 0026.945 25zm-5.22-9.71l-.036.008A9.008 9.008 0 0015.055 23h3.995a16.3 16.3 0 012.675-7.71zm2.275.26A14.288 14.288 0 0021.055 23h5.887A14.3 14.3 0 0024 15.55zm2.274-.261l.189.29A16.336 16.336 0 0128.947 23h3.998a9.008 9.008 0 00-6.671-7.71z",
    id: "globe_svg__a"
  }));
};

var _default = SvgGlobe;
exports.default = _default;